import { useEffect } from 'react';
import { useWizard } from 'react-use-wizard';

// URL parameter management helpers
export const getStepKeyFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const step = urlParams.get('step');
  return step;
};
export const setStepKeyInUrl = stepKey => {
  const url = new URL(window.location);
  if (stepKey) {
    url.searchParams.set('step', stepKey);
  } else {
    url.searchParams.delete('step');
  }
  window.history.replaceState({}, '', url);
};
const StepUrlUpdater = _ref => {
  let {
    indexToKeyMap
  } = _ref;
  const {
    activeStep
  } = useWizard();
  useEffect(() => {
    const stepKey = indexToKeyMap[activeStep] || null;
    const fromUrl = getStepKeyFromUrl();
    if (!((stepKey === null || stepKey === void 0 ? void 0 : stepKey.length) > 0)) {
      return;
    }
    if (fromUrl !== stepKey) {
      setStepKeyInUrl(stepKey);
    }
  }, [activeStep, indexToKeyMap]);
  return null;
};
export default StepUrlUpdater;